import React from 'react';
import { StepIntro, TextAreaField, TextField } from '../fields';

export default function StepBusiness({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  return (
    <div className="space-y-4">
      <StepIntro title="Business details" text="These appear on your website's contact page, footer and Google listing." />
      <TextField id="business_name" label="Business name" value={data.business_name} onChange={f('business_name')} placeholder="e.g. Smith Resin Driveways" />
      <TextField id="contact_name" label="Contact name" value={data.contact_name} onChange={f('contact_name')} placeholder="Your name" />
      <TextAreaField id="address" label="Business address" value={data.address} onChange={f('address')} rows={3} placeholder="Street, town, postcode" />
      <div className="grid sm:grid-cols-2 gap-4">
        <TextField id="telephone" label="Telephone number" value={data.telephone} onChange={f('telephone')} type="tel" inputMode="tel" placeholder="07…" />
        <TextField id="whatsapp" label="WhatsApp number" value={data.whatsapp} onChange={f('whatsapp')} type="tel" inputMode="tel" optional placeholder="Same as telephone?" />
      </div>
      <TextField id="email" label="Email address" value={data.email} onChange={f('email')} type="email" inputMode="email" placeholder="info@yourbusiness.co.uk" />
      <TextAreaField id="opening_hours" label="Opening hours" value={data.opening_hours} onChange={f('opening_hours')} rows={3} placeholder={'Mon–Fri 8am–6pm\nSat 9am–1pm'} />
      <div className="grid sm:grid-cols-2 gap-4">
        <TextField id="company_number" label="Company number" value={data.company_number} onChange={f('company_number')} optional />
        <TextField id="vat_number" label="VAT number" value={data.vat_number} onChange={f('vat_number')} optional />
      </div>
    </div>
  );
}
